import React from 'react';

function Products() {
  return (
    <div>
        Welcome to Products Component.
    </div>
  );
}

export default Products;
